import React, {
    useEffect,
    useState,
    useMemo, useContext,
} from 'react';
import PropTypes from 'prop-types';
import ClienteDirectoContext from "./ClienteDirectoContext";
import axios from "axios";
import GenericDataContext from "../GenericDataContext";
import {companiesDict, companiesIdDict} from "../../constants/companiesDict";
import {provinciasList} from "../../constants/provincias";

const coberturasAutomotorNames = {
    "names": {
        "RC": "Responsabilidad civil",
        "IT": "Incendio total",
        "IP": "Incendio parcial",
        "RHT": "Robo y/o hurto total",
        "RHP": "Robo y/o hurto parcial",
        "AT": "Accidente total",
        "APD": "Accidente parcial según deducible",
        "LTP": "Lock out o tumulto popular",
        "GTI": "Granizo / Terremoto / Indundación total y parcial",
        "RCR": "Rotura de cristales",
        "RCE": "Rotura de cerraduras",
        "RRH": "Reposición de ruedas en caso de robo o hurto",
        "DPR": "Daños parciales al amparo del Robo Total",
        "CPL": "Extensión de Cobertura a países limítrofes",
        "AV": "Asistencia al vehículo",
        "SCS": "CLEAS (Sistema Compensación de Siniestros)",
    },
}

const coberturasMotovehiculoNames = {
    "names": {
        "RC": "Responsabilidad civil",
        "IT": "Incendio total",
        "IP": "Incendio parcial",
        "RHT": "Robo y/o hurto total",
        "RHP": "Robo y/o hurto parcial",
        "AT": "Accidente total",
        "GIT": "Granizo / Inundación / Terremoto",
        "DPC": "Daños por robo o intento de robo (Cerraduras)",
        "DT": "Cláusula destrucción total del 80%",
        "AV": "Asistencia al vehículo",
        "EC": "Extensión de Cobertura a países limítrofes"
    },
}

const ClienteDirectoContextProvider = ({children}) => {
        const {idPaginaPolkista, idPolkista} = useContext(GenericDataContext)
        const [idRowPaginasPolkista, setIdRowPaginasPolkista] = useState(null);
        const [idRowPolkista, setIdRowPolkista] = useState(null);
        const [description, setDescription] = useState(null);
        const [habilitado, setHabilitado] = useState(null);
        const [datosPolkista, setDatosPolkista] = useState(null);
        const [redesSociales, setRedesSociales] = useState(null);
        const [datosMaster, setDatosMaster] = useState(null);
        const [templateId, setTemplateId] = useState(null);
        const [activeProducts, setActiveProducts] = useState(null);
        const [logo, setLogo] = useState(null);
        const genericOptionsFormasDePago = [{label: 'Tarjeta de crédito', value: 'TC'}, {
            label: 'Débito por CBU',
            value: 'CBU'
        }];
        // VEHICULO
        const [autosMarcas, setAutosMarcas] = useState(null)
        const [localidades, setLocalidades] = useState(null)
        // MOTO
        const [motosMarcas, setMotosMarcas] = useState(null)
        //HOGAR
        const [coberturasInfo, setCoberturasInfo] = useState(null);
        //PRODUCTOS
        const [coberturasProductsInfo, setCoberturasProductsInfo] = useState(null);

        const [isReady, setIsReady] = useState(false);
        const [isCotizarReady, setIsCotizarReady] = useState(false);

        const coberturasAdicionalesOrder = [48, 36, 37, 26];

        useEffect(() => {
                let shouldUpdate = true;

                const init = async () => {
                    let coberturasInfoDict = {};
                    let urlRequestOne = process.env.REACT_APP_BACK_SERVER + `/newConsultarCanalDigital/?id_cd=${idPaginaPolkista}`
                    let urlRequestTwo = process.env.REACT_APP_BACK_SERVER + '/cd/getDatosCotizar'
                    let urlRequestThree = process.env.REACT_APP_QUOTATION_MICROSERVICE + '/getInformacionCoberturas'

                    const requestOne = axios.get(urlRequestOne);
                    const requestTwo = axios.get(urlRequestTwo);
                    const requestThree = axios.get(urlRequestThree);

                    requestOne.then((responseOne) => {
                        if (!shouldUpdate) return;
                        const resp = responseOne['data']
                        let masterResp = resp['datos_master']

                        setHabilitado(resp['habilitada'])
                        setIdRowPaginasPolkista(idPaginaPolkista)
                        setIdRowPolkista(idPolkista)
                        setDescription(resp['descripcion'])
                        setDatosPolkista(resp['datos_polkista'])
                        setDatosMaster({
                            nombre: masterResp['Nombre'],
                            apellido: masterResp['Apellido'],
                            email: masterResp['Email'],
                            direccion: `${masterResp['Direccion']}`,
                            matricula: masterResp['matricula'],
                            telefono: masterResp['Telefono'],
                            id_polkista: masterResp['id_polkista'],
                        })
                        setRedesSociales(resp['redes_sociales'] ?? [])
                        setTemplateId(resp['template'])
                        setLogo(resp['logo']);
                        setActiveProducts(resp['productos']);

                        setIsReady(true);
                    });

                    axios.all([requestTwo, requestThree])
                        .then(axios.spread((responseTwo, responseThree) => {
                            if (!shouldUpdate) return;

                            let options = responseTwo['data']['localidades'].map(d => ({
                                "value": `${d.CodPostal.toString()},${d.CodSancorLocalidad.toString()},${d.CodRUSLocalidad.toString()}`,
                                "label": '(' + d.CodPostal.toString() + ') ' + d.Localidad
                            }));
                            setLocalidades(options)

                            setCoberturasInfo(responseTwo['data']['coberturas_hogar'])
                            setAutosMarcas(responseTwo['data']['marcas_auto'].map(d => ({
                                "value": d,
                                "label": d
                            })))
                            setMotosMarcas(responseTwo['data']['marcas_moto'].map(d => ({
                                "value": d,
                                "label": d
                            })))

                            coberturasInfoDict["vehiculo"] = {
                                ...responseThree["data"]["coberturas_auto"],
                                ...coberturasAutomotorNames
                            }
                            coberturasInfoDict["motovehiculo"] = {
                                ...responseThree["data"]["coberturas_motovehiculo"],
                                ...coberturasMotovehiculoNames
                            }

                            setCoberturasProductsInfo(coberturasInfoDict)
                            setIsCotizarReady(true);
                        }));
                }
                init();
                return () => {
                    shouldUpdate = false;
                };
            }, []
        )


        const context = useMemo(() => ({
            habilitado,
            idRowPaginasPolkista,
            idRowPolkista,
            description,
            datosPolkista,
            datosMaster,
            redesSociales,
            templateId,
            logo,
            genericOptionsFormasDePago,
            activeProducts,
            autosMarcas,
            motosMarcas,
            localidades,
            coberturasInfo,
            coberturasAdicionalesOrder,
            companiesDict,
            companiesIdDict,
            provinciasList,
            coberturasProductsInfo,
            isReady,
            isCotizarReady,
        }), [
            habilitado,
            idRowPaginasPolkista,
            idRowPolkista,
            description,
            datosPolkista,
            datosMaster,
            redesSociales,
            templateId,
            logo,
            genericOptionsFormasDePago,
            activeProducts,
            autosMarcas,
            motosMarcas,
            localidades,
            coberturasInfo,
            coberturasAdicionalesOrder,
            companiesDict,
            companiesIdDict,
            provinciasList,
            coberturasProductsInfo,
            isReady,
            isCotizarReady,
        ]);

        return (
            <ClienteDirectoContext.Provider value={context}>
                {children}
            </ClienteDirectoContext.Provider>
        );
    }
;

ClienteDirectoContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ClienteDirectoContextProvider;